<div class="container">
  <div class="row mt-4">
    <div class="col-8">
      <h4>Lista de Formulário</h4>
    </div>
    <div class="col-4 text-right">
      <button *ngIf="isUserDev" class="btn btn-primary col-6" (click)="new()">Novo</button>
    </div>
    <div class="col-12">
      <hr>
    </div>
    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Descrição</th>
            <th scope="col">Total de Fórmula</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listForm">
            <td>{{item.name}}</td>
            <td>{{item.description}}</td>
            <td [ngPlural]="item.countFormule">
              <ng-template ngPluralCase="=0">Nenhuma fórmula cadastrada</ng-template>
              <ng-template ngPluralCase="=1">1 fórmula</ng-template>
              <ng-template ngPluralCase="other">{{item.countFormule}} fórmulas</ng-template>
            </td>
            <td class="text-center">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">                

                <button *ngIf="isUserDev" mat-button color="primary" class="w-100" matTooltip="Editar Formulário"
                  (click)="edit(item.id)">
                  <i class="fa fa-edit fa-1x btnIcon"></i>
                  Editar Formulário
                </button>

                <button mat-button color="primary" class="w-100" matTooltip="Visualizar Fórmulas"
                  (click)="viewFormule(item.id)">
                  <i class="fa fa-list fa-1x btnIcon"></i>
                  Fórmulas
                </button>                
                
              </mat-menu>
            </td>
          </tr>
        </tbody>        
      </table>
      <div class="col-12 text-center" *ngIf="listForm.length === 0">
        <label for="">Nenhum registro encontrado</label>
      </div>
    </div>
  </div>
</div>